import { render } from "./SideBarLink.vue?vue&type=template&id=6c585c56&scoped=true"
import script from "./SideBarLink.vue?vue&type=script&lang=js"
export * from "./SideBarLink.vue?vue&type=script&lang=js"

import "./SideBarLink.vue?vue&type=style&index=0&id=6c585c56&scoped=true&lang=css"
import "./SideBarLink.vue?vue&type=style&index=1&id=6c585c56&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c585c56"],['__file',"src/components/SideBarLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c585c56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c585c56', __exports__)) {
    console.log('reload')
    api.reload('6c585c56', __exports__)
  }
  
  module.hot.accept("./SideBarLink.vue?vue&type=template&id=6c585c56&scoped=true", () => {
    console.log('re-render')
    api.rerender('6c585c56', render)
  })

}


export default __exports__